import { PropsWithChildren } from "react";

import { color } from "emoreg/const";
import { Box } from "emoreg/layouts";

export const DropdownPopOverFooter = ({ children }: PropsWithChildren<{}>) => {
  return (
    <Box padding={4} borderTop={`1px solid ${color.grey.light}`}>
      {children}
    </Box>
  );
};
